<template>
    <div>
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-primary" v-on:click="showModal = true">
          {{ $t('Add new slot') }}
        </button>

        <SlotSetting :zone="zone"
                    :stage="stage"
                    :show="showModal"
                    v-on:save-slot="saveSlot($event)"
                    v-on:close="showModal = false"
                    id="addSlotModal"></SlotSetting>
    </div>
</template>

<script>
    import SlotSetting from './SlotSetting.vue';
    export default {
        name: "add-slot",
        components: {
          SlotSetting,
        },
        props: {
            zone: {
                default: 'UTC'
            },
            stage: {
                default: null,
            }
        },
        data() {
            return {
                showModal: false
            }
        },
        methods: {
            saveSlot(e) {
                this.$emit('add-slot',e)
                this.showModal = false
            }
        },
    }
</script>

<style scoped>

</style>